import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Pagination } from 'antd';
import { isMobile } from "react-device-detect";
import MobileCallHistory from './mobile/m-callHistory';
import DesktopCallHistory from './desktop/callHistory';
import moment from 'moment';

const { Column } = Table;


class CallHistory extends Component {
	constructor(props) {
		super(props);
		this.state={
			searchText : ""
		}
		this.handleInputChange = this.handleInputChange.bind(this);
	}

	handleInputChange(val){
		this.setState({
			searchText: val
		})
	}


	render() {
		if(isMobile){
			return <MobileCallHistory {...this.props}
									{...this.state}
									handleInputChange={this.handleInputChange} />
		}else{
			return <DesktopCallHistory {...this.props}
									{...this.state}
									handleInputChange={this.handleInputChange} />
		}
	}
}

export default connect(
	state => state
)(CallHistory);
